export const theme = {
  fonts: {
    display: "'Playfair Display', Georgia, serif",
    body: "'Nunito', system-ui, sans-serif",
  },
  colors: {
    // Primary
    terracotta: '#C4673A',
    terracottaDark: '#8B3E1F',
    terracottaLight: '#E8A882',

    // Backgrounds
    cream: '#FDF6EE',
    bgSecondary: '#FAF3E8',
    card: '#FFFFFF',

    // Accents
    peach: '#F2C9A8',
    honeyGold: '#D4A843',
    sage: '#7A8C6E',
    sageLight: '#D3DDCC',

    // Text
    textPrimary: '#5C3D2E',
    textSecondary: '#9A7A60',
    textTertiary: '#BBA090',

    // Borders
    border: '#E8D5BF',
    borderStrong: '#D4B99A',

    // Status
    successBg: '#D3DDCC',
    successText: '#3D5030',
    warningBg: '#F5E4B0',
    warningText: '#7A5A10',
    errorBg: '#FDECEA',
    errorText: '#C0392B',
  },
  layout: {
    screenPadding: 20,
    cardRadius: 18,
    buttonRadius: 14,
    inputRadius: 12,
  },
}